import { render, staticRenderFns } from "./SolicitarTarea.vue?vue&type=template&id=a8e11e18&"
import script from "./SolicitarTarea.vue?vue&type=script&lang=js&"
export * from "./SolicitarTarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports